var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-overlay', {
    attrs: {
      "show": _vm.processing,
      "bg-color": "#ffffff",
      "z-index": "501",
      "opacity": "0.6"
    }
  }, [_c('h6', {
    staticClass: "mb-1 mt-1 text-center"
  }, [_vm._v("註冊")]), _vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form', {
    staticClass: "av-tooltip tooltip-label-bottom",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-label"
  }, [_vm._v("Email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.email,
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "電子郵件"
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-label"
  }, [_vm._v("密碼")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": _vm.password
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-label"
  }, [_vm._v("確認密碼")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password_confirmation,
      expression: "password_confirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": _vm.password_confirmation
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.password_confirmation = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-label"
  }, [_vm._v("姓名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.last_name,
      expression: "last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "蔡依林"
    },
    domProps: {
      "value": _vm.last_name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.last_name = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-label"
  }, [_vm._v("稱謂")]), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-block",
    class: {
      'btn-outline-secondary': _vm.sexual !== 'female',
      'btn-outline-primary': _vm.sexual === 'female'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.selectSexual('female');
      }
    }
  }, [_vm._v("小姐")])]), _c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-block",
    class: {
      'btn-outline-secondary': _vm.sexual !== 'male',
      'btn-outline-primary': _vm.sexual === 'male'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.selectSexual('male');
      }
    }
  }, [_vm._v("先生")])])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    staticClass: "float-label"
  }, [_vm._v("年")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.birthday.year,
      expression: "birthday.year"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "年"
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.birthday, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("請選擇")]), _vm._l(_vm.yearSelects, function (year, index) {
    return _c('option', {
      key: index
    }, [_vm._v(_vm._s(year))]);
  })], 2)]), _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    staticClass: "float-label"
  }, [_vm._v("月")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.birthday.month,
      expression: "birthday.month"
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.birthday, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("請選擇")]), _vm._l(_vm.monthSelects, function (month, index) {
    return _c('option', {
      key: index
    }, [_vm._v(_vm._s(month))]);
  })], 2)]), _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    staticClass: "float-label"
  }, [_vm._v("日")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.birthday.day,
      expression: "birthday.day"
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.birthday, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("請選擇")]), _vm._l(_vm.daySelects, function (day, index) {
    return _c('option', {
      key: index
    }, [_vm._v(_vm._s(day))]);
  })], 2)])])]), _c('b-button', {
    staticClass: "btn-block secondary-button mt-4",
    attrs: {
      "size": "lg",
      "disabled": _vm.processing
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 註冊 ")]), _c('div', {
    staticClass: "mt-4"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/' + _vm.$route.params.org_code + '/liff/login'
      }
    }
  }, [_vm._v("返回登入")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }